// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** Maestro */
export const Maestro = createBankIcon({
  name: "Maestro",
  slug: "maestro",
  compe: null,
  color: "#ffffff",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#ffffff;fill-opacity:1\"\n     id=\"maestro_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(21.0155,32.0935) scale(0.29000)\">\n    <path d=\"M127,110.4H72.9V13.2H127V110.4z\" style=\"fill:#7375CF\" />\n    <path d=\"M76.4,61.8c0-19.7,9.2-37.3,23.6-48.6C89.5,4.9,76.2,0,61.8,0C27.7,0,0,27.7,0,61.8s27.7,61.8,61.8,61.8\n\t\t\tc14.4,0,27.7-4.9,38.2-13.2C85.6,99.1,76.4,81.5,76.4,61.8\" style=\"fill:#EB001B\" />\n    <path d=\"M200,61.8c0,34.1-27.7,61.8-61.8,61.8c-14.4,0-27.7-4.9-38.2-13.2c14.4-11.3,23.6-28.9,23.6-48.6\n\t\t\ts-9.2-37.3-23.6-48.6C110.5,4.9,123.8,0,138.2,0C172.3,0,200,27.7,200,61.8\" style=\"fill:#00A2E5\" />\n  </g>",
});
